import React from "react";
import Checkbox from "./Checkbox";
import LoadingCenter from "./LoadingCenter";
import { ArrowLeft, X, MoreVertical, MessageSquare, Search } from "react-feather";
import {
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CDropdownToggle,
} from "@coreui/react";
import moment from "moment";

function ChatList({
  isNewChat,
  handleChatBack,
  isModalOptionsOpen,
  toggleOptionsMenu,
  openNewContactPopup,
  isChatsFetching,
  handleScroll,
  scrollRef,
  openFilterByTags,
  clearTagsFilter,
  filtroTag,
  // Master mode extras
  isMasterMode,
  canViewAllChats,
  chatScope,
  toggleChatScope,
  openFilterBySeller,
  loadAllChats,
  masterGate,
  onMasterFilter,
  onMasterLoadAll,
  selectedSellerName,
  search,
  handleSearchByName,
  handleSearchUsersByName,
  available,
  loadVacationContacts,
  hasChats,
  chats,
  list,
  hasMoreChats,
  isLoadingMoreChats,
  loadMoreChats,
  users,
  listUsers,
  countRef,
  onChangeAllChats,
  onChangeCheckChat,
  onSubmitChat,
  fetchMessagesById,
  currentChatId,
  transferConversation,
  transferConversationProspect,
  fixConversation,
  markAsUnread,
  user,
  theme,
  chooseChat,
}) {
  const userGroupId = Number(user?.group_id);
  const canTransferChat = [1, 8].includes(userGroupId);

  return (
    <div className="chat-list">
      <div className="header header-chat-list border-bottom">
        <span>
          {isNewChat && (
            <button onClick={handleChatBack} className="action-btn mr-20">
              <ArrowLeft />
            </button>
          )}
          {isNewChat ? "Nova conversa" : "Conversas"}
        </span>

        {!isNewChat && (
          <div>
            <button onClick={openNewContactPopup} className="action-btn">
              <MessageSquare />
            </button>

            <button onClick={toggleOptionsMenu} className="action-btn ml-10">
              {isModalOptionsOpen ? <X /> : <MoreVertical />}
            </button>
          </div>
        )}
      </div>

      <div className="chat-list-scroll" ref={scrollRef} onScroll={handleScroll}>
        {isModalOptionsOpen && (
          <div className="chat-actions">
            <ul>
              <li onClick={openFilterByTags}>
                <label>Filtrar por tags</label>
              </li>
              {isMasterMode && (
                <li onClick={openFilterBySeller}>
                  <label>Filtrar por vendedor</label>
                </li>
              )}
              {!!filtroTag && (
                <li style={{ marginTop: "20px" }} onClick={clearTagsFilter}>
                  <label>Limpar Filtro</label>
                </li>
              )}
              {isMasterMode && (
                <li style={{ marginTop: "20px" }} onClick={(e) => { e.preventDefault(); loadAllChats && loadAllChats(); }}>
                  <label>Carregar todos</label>
                </li>
              )}
            </ul>
          </div>
        )}

        <form onSubmit={onSubmitChat}>
          <div className="search">
            <div className="inner-search">
              <div className="search-icon">
                <Search size={24} />
              </div>
              {isNewChat ? (
                <input className="search-input" type="text" placeholder="Pesquisar" onChange={(e) => handleSearchUsersByName(e.target.value)} value={search} />
              ) : (
                <input className="search-input" type="text" placeholder="Pesquisar" onChange={(e) => handleSearchByName(e.target.value)} value={search} />
              )}
            </div>
          </div>

          {!isNewChat && canViewAllChats && (
            <div className="chat-scope-toggle">
              <button
                type="button"
                className={`chat-scope-toggle__button ${chatScope === "all" ? "is-active" : ""}`}
                onClick={toggleChatScope}
              >
                {chatScope === "all" ? "Ver meus chats" : "Ver todos"}
              </button>
            </div>
          )}

          {isMasterMode && !masterGate && selectedSellerName && (
            <div className="mb-10">
              <div className="notfound-text">Vendedor selecionado: {selectedSellerName}</div>
            </div>
          )}

          {isMasterMode && masterGate && (
            <div>
              <div className="notfound-text">Filtre por um vendedor</div>
              <a className="notfound-a-text" onClick={(e) => { e.preventDefault(); onMasterLoadAll && onMasterLoadAll(); }}>Ou então carregue todos aqui</a>
            </div>
          )}

          {isNewChat && !isChatsFetching && (
            <div className="mb-10">
              <div className="notfound-text">Novo contato</div>
              <a className="notfound-a-text" onClick={openNewContactPopup}>Adicionar novo contato</a>
            </div>
          )}

          {available && isNewChat && !isChatsFetching && (
            <div>
              <div className="notfound-text">Disponíveis</div>
              <a className="notfound-a-text pb-0" onClick={(e) => { e.preventDefault(); loadVacationContacts() }}>Carregar contatos de férias</a>
            </div>
          )}

          {!isChatsFetching && countRef.current > 0 && !isNewChat && (
            <ul className="checkbox-navigation">
              <li className="checkbox-navigation__item">
                <label className="checkbox-navigation__label">
                  <input type="checkbox" className="checkbox-navigation__checkbox" onChange={onChangeAllChats} />
                  <span className="checkbox-navigation__title checkbox-navigation__title--margin-left">Selecionar todos os chats</span>
                </label>
              </li>
              <li className="checkbox-navigation__item">
                <button type="submit" className="format__btn checkbox-navigation__label checkbox-navigation__title">
                  Enviar msg (p/ chats selecionados)
                </button>
              </li>
            </ul>
          )}

          {isChatsFetching && !(isMasterMode && masterGate) && <LoadingCenter />}

          {!isChatsFetching && !isNewChat && chats.length <= 0 && !(isMasterMode && masterGate) && (
            <div>
              <div className="notfound-text">Nenhuma conversa encontrada</div>
              <a className="notfound-a-text" onClick={(e) => { e.preventDefault(); }}>Tentar novamente</a>
            </div>
          )}

          {!isNewChat && hasChats.length > 0 && (
            <div className="padding-10">
              <button className="btn btn-primary w-100" type="submit">Enviar para selecionados</button>
            </div>
          )}

          {chats.length > 0 ? (
            <>
              {list.map((chat, index) => (
                <div key={chat.chat_id || chat.id || index} className={`item position-relative ${chat.admin_id == 0 && "bg-newChat"} ${chat.transfered && "bg-light-brown"} ${chat.juridic && "bg-light-red"} ${chat.chat_id == currentChatId && "chat-atual"}`}>
                  <div className="item-left">
                    <div className="photo-wrapper">
                      <Checkbox value={chat.id} checked={chat.checked} onChange={event => onChangeCheckChat(event, chat)} />
                      <div className="photo" style={{ backgroundImage: `url(${chat.profile_pic})` }}></div>
                    </div>
                  </div>
                  <div className="item-right" onClick={(e) => { e.preventDefault(); fetchMessagesById(chat.chat_id, chat.id, chat.admin_id, chat) }}>
                    <span className={`name text-limiter ${!chat.read && "text-orange"}`}>{chat.name[0].toUpperCase() + chat.name.substr(1).toLowerCase()}</span>
                    {(() => {
                      const unread = Number(chat.notReadMessages || 0);
                      const messagePreview = chat.message ? String(chat.message).trim() : "";
                      const lastFailed = (
                        chat.last_message_status === 'failed' ||
                        chat.lastMessageStatus === 'failed' ||
                        chat.last_message_error ||
                        chat.lastMessageError ||
                        chat.last_message_failed ||
                        chat.lastMessageFailed ||
                        chat.last_sent_failed ||
                        chat.lastSentFailed ||
                        chat.message_failed ||
                        chat.messageFailed ||
                        messagePreview.toLowerCase().includes("mensagem não enviada")
                      );
                      if (unread > 0) {
                        return <span className="current-message text-orange">{unread}</span>;
                      }
                      if (lastFailed) {
                        return <span className="current-message text-orange">Mensagem não enviada</span>;
                      }
                      return <span className="current-message">{messagePreview}</span>;
                    })()}
                    {chat.cuidandochat ? (
                      <span className="transfered">{"Vendedor " + chat.name_admin}</span>
                    ) : chat.transfered ? (
                      <span className="transfered">Conversa RECEBIDA</span>
                    ) : chat.updateAt ? (
                      <span className="transfered">{moment(chat.updateAt).fromNow()}</span>
                    ) : (
                      <span className="transfered">{"Criado " + moment(chat.createdAt).fromNow()}</span>
                    )}
                  </div>

                  {!chat.cuidandochat && (
                    <div className="position-absolute action-bnt-chat">
                      <CDropdown className="message-action-btn" direction="dropstart">
                        <CDropdownToggle color="secondary">&#11167;</CDropdownToggle>
                        <CDropdownMenu>
                          {canTransferChat && userGroupId === 8 ? (
                            <>
                              <CDropdownItem onClick={e => transferConversation(e, chat)}>Transferência solicitada</CDropdownItem>
                              <CDropdownItem onClick={e => transferConversationProspect(e, chat)}>Transferir conversa</CDropdownItem>
                            </>
                          ) : canTransferChat ? (
                            <CDropdownItem onClick={e => transferConversation(e, chat)}>Transferir conversa</CDropdownItem>
                          ) : null}
                          <CDropdownItem onClick={e => fixConversation(e, chat.chat_id)}>{chat.pinned ? "Desafixar" : "Fixar"} conversa</CDropdownItem>
                          <CDropdownItem onClick={e => markAsUnread(e, chat.chat_id)}>Marcar como {chat.unread ? "lida" : "não lida"}</CDropdownItem>
                        </CDropdownMenu>
                      </CDropdown>
                    </div>
                  )}

                  {chat.transfered && (
                    <div className="position-absolute chat-pin">
                      <img src={require("../imgs/transferir.png")} />
                    </div>
                  )}
                  {chat.cuidandochat && (
                    <div className="position-absolute social-icon-chats">
                      <img src={require("../imgs/coqueiro.png")} width="16" />
                    </div>
                  )}
                  {chat.pinned && (
                    <div className="position-absolute chat-pin">
                      {theme === "dark" ? (
                        <img src={require("../imgs/pin-white.png")} />
                      ) : (
                        <img src={require("../imgs/pin.png")} />
                      )}
                    </div>
                  )}
                </div>
              ))}
              {!isNewChat && hasMoreChats && (
                <div className="chat-load-more">
                  <button type="button" onClick={loadMoreChats} disabled={isLoadingMoreChats}>
                    {isLoadingMoreChats ? "Carregando..." : "Carregar mais"}
                  </button>
                </div>
              )}
            </>
          ) : (
            users.length > 0 && (
              listUsers?.map((user, index) => (
                <div key={index} className={`item position-relative`} onClick={() => {
                  if (!user.contains_chat) {
                    chooseChat(user);
                  } else {
                    alert("Você já possui chat com essa pessoa.");
                  }
                }}>
                  <div className="item-left">
                    <div className="photo-wrapper">
                      <div className="photo" style={{ backgroundImage: `url(${user.profile_pic})` }}></div>
                    </div>
                  </div>
                  <div className="item-right">
                    <span className={`text-limiter name`}>{user.name[0].toUpperCase() + user.name.substr(1).toLowerCase()}</span>
                  </div>
                </div>
              ))
            )
          )}
        </form>
      </div>
    </div>
  );
}

export default ChatList;
